export default [
  {
    title: '月份',
    key: 'month',
    fixed: true,
    width: 58
  },
  {
    title: '设计人员',
    key: 'designerName',
    fixed: true,
    width: 80
  },
  {
    title: '个人总积分',
    key: 'sumF',
    fixed: true,
    width: 80
  },
  {
    title: '个人积分/天',
    key: 'averageDayF',
    fixed: true,
    width: 84
  },
  {
    title: '工作天数',
    key: 'workDay',
    fixed: true,
    width: 76
  },
  {
    title: '角色-S',
    key: 'roleSf',
    width: 86
  },
  {
    title: '角色-A',
    key: 'roleAf',
    width: 86
  },
  {
    title: '角色-B',
    key: 'roleBf',
    width: 86
  },
  {
    title: '角色-C',
    key: 'roleCf',
    width: 86
  },
  {
    title: '道具-A',
    key: 'propsAf',
    width: 86
  },
  {
    title: '道具-B',
    key: 'propsBf',
    width: 86
  },
  {
    title: '道具-C',
    key: 'propsCf',
    width: 86
  },
  {
    title: '地编-SS',
    key: 'mapSsf',
    width: 96
  },
  {
    title: '地编-S',
    key: 'mapSf',
    width: 86
  },
  {
    title: '地编-A',
    key: 'mapAf',
    width: 86
  },
  {
    title: '地编-B',
    key: 'mapBf',
    width: 86
  },
  {
    title: '地图-S',
    key: 'platSf',
    width: 86
  },
  {
    title: '地图-A',
    key: 'platAf',
    width: 86
  },
  {
    title: '地图-B',
    key: 'platBf',
    width: 86
  },
  {
    title: '序列-C',
    key: 'orderCf',
    width: 86
  },
  {
    title: '序列-D',
    key: 'orderDf',
    width: 86
  },
  {
    title: 'Layout-A',
    key: 'layoutAf',
    width: 106
  },
  {
    title: 'Layout-B',
    key: 'layoutBf',
    width: 106
  },
  {
    title: '特效-A',
    key: 'specialAf',
    width: 86
  },
  {
    title: '特效-B',
    key: 'specialBf',
    width: 86
  },
  {
    title: '特效-C',
    key: 'specialCf',
    width: 86
  },
  {
    title: '渲染-S',
    key: 'renderingSf',
    width: 86
  },
  {
    title: '渲染-A',
    key: 'renderingAf',
    width: 86
  },
  {
    title: '渲染-B',
    key: 'renderingBf',
    width: 86
  },
  {
    title: '渲染-C',
    key: 'renderingCf',
    width: 86
  },
  {
    title: '后期-A',
    key: 'lateAf',
    width: 86
  },
  {
    title: '后期-B',
    key: 'lateBf',
    width: 86
  },
  {
    title: '后期-C',
    key: 'lateCf',
    width: 86
  },
  {
    title: '绑定-A',
    key: 'bindAf',
    width: 86
  },
  {
    title: '绑定-B',
    key: 'bindBf',
    width: 86
  },
  {
    title: '绑定-C',
    key: 'bindCf',
    width: 86
  },
  {
    title: '绑定-D',
    key: 'bindDf',
    width: 86
  },
  {
    title: '动画-A3',
    key: 'videoA3f',
    width: 86
  },
  {
    title: '动画-A2',
    key: 'videoA2f',
    width: 86
  },
  {
    title: '动画-A1',
    key: 'videoA1f',
    width: 86
  },
  {
    title: '动画-B2',
    key: 'videoB2f',
    width: 86
  },
  {
    title: '动画-B1',
    key: 'videoB1f',
    width: 86
  },
  {
    title: '动画-C',
    key: 'videoCf',
    width: 86
  },
  {
    title: '蓝图-S',
    key: 'blueprintSf',
    width: 86
  },
  {
    title: '蓝图-A',
    key: 'blueprintAf',
    width: 86
  },
  {
    title: '蓝图-B',
    key: 'blueprintBf',
    width: 86
  },
  {
    title: '蓝图-C',
    key: 'blueprintCf',
    width: 86
  },
  {
    title: '界面',
    key: 'panelf',
    width: 86
  },
  {
    title: '动画界面',
    key: 'animationInterfacef',
    width: 86
  },
  {
    title: 'icon',
    key: 'iconf',
    width: 86
  },
  {
    title: 'Loading',
    key: 'loadingf',
    width: 86
  },
  {
    title: 'UI',
    key: 'uif',
    width: 86
  },
  {
    title: '落地页',
    key: 'loadingPagef',
    width: 86
  },
  {
    title: '五图',
    key: 'fiveFiguref',
    width: 86
  },
  {
    title: 'Logo',
    key: 'logof',
    width: 86
  },
  {
    title: '平面投放',
    key: 'graphicLaunchf',
    width: 86
  },
  {
    title: '场景原画-S',
    key: 'scenePaintingSf',
    width: 86
  },
  {
    title: '场景原画-A',
    key: 'scenePaintingAf',
    width: 86
  },
  {
    title: '角色原画-S',
    key: 'rolePaintingSf',
    width: 86
  },
  {
    title: '角色原画-A',
    key: 'rolePaintingAf',
    width: 86
  },
  {
    title: '角色原画-B',
    key: 'rolePaintingBf',
    width: 86
  },
  {
    title: '道具/UI原画-A',
    key: 'propsPaintingAf',
    width: 96
  },
  {
    title: '道具/UI原画-B',
    key: 'propsPaintingBf',
    width: 96
  },
  {
    title: '道具/UI原画-C',
    key: 'propsPaintingCf',
    width: 96
  },
  {
    title: '纯原创icon',
    key: 'originalIconf',
    width: 96
  },
  {
    title: '纯原创loading',
    key: 'originalLoadingf',
    width: 96
  },
  {
    title: '操作',
    key: 'control',
    fixed: true,
    width: 70
  }
]
